import {fetchError, fetchStart, fetchSuccess} from "./Common";
import {CREATE_AC_SUCCESS, FETCH_ACTIVITY_SNO_SUCCESS_FOR_ACTIVITY_CLOSURE} from "../../constants/ActionTypes";
import {history} from "../store";
import axios from 'util/Api'


export const fetchActivityResourceSuccess = (data) => {
  return {
    type: FETCH_ACTIVITY_SNO_SUCCESS_FOR_ACTIVITY_CLOSURE,
    data
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_AC_SUCCESS,
    data
  };
};

export const fetchActivitySno = () => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const response = await axios.get(`/invoice-entry/activity`);
      dispatch(fetchSuccess());
      dispatch(fetchActivityResourceSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/activity-closure`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess(response.data));
      if(response && response.data) {
        history.push('/dashboard');
      }
      else {
        history.push('/dashboard');
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};
